import React, { useState } from 'react';
import './SecretCode.css';

function SecretCode() {
  const [codeValues, setCodeValues] = useState(['', '', '', '', '']);

  const handleCodeChange = (index, value) => {
    if (value.length <= 1) {
      const newValues = [...codeValues];
      newValues[index] = value.toUpperCase();
      setCodeValues(newValues);
      
      // Auto-focus next input
      if (value && index < 4) {
        const nextInput = document.getElementById(`code-input-${index + 1}`);
        if (nextInput) nextInput.focus();
      }
    }
  };

  const handleSubmit = () => {
    const code = codeValues.join('');
    console.log('Entered code:', code);
    // Here you would handle the code validation
  };

  return (
    <div className="secret-code">
      <div className="secret-code-content">
        <div className="lock-icon">
          <img src="/img/lock_2.svg" alt="Lock" className="lock-image" style={{filter: 'invert(1)'}}/>
        </div>
        
        <h2 className="secret-title">Mentees/Mentors Only</h2>
        <p className="secret-subtitle">Enter your Secret Code to access.</p>
        
        <div className="code-inputs">
          {codeValues.map((value, index) => (
            <input
              key={index}
              id={`code-input-${index}`}
              type="text"
              value={value}
              onChange={(e) => handleCodeChange(index, e.target.value)}
              className="code-input"
              maxLength="1"
            />
          ))}
        </div>
        
        <button className="enter-code-button" onClick={handleSubmit}>
          Enter Your Code
        </button>
      </div>
    </div>
  );
}

export default SecretCode; 